import { get } from "../client";

const BASE_URL = process.env.REACT_APP_BE_URL as string;

const post = <T>(path: string, body: unknown) =>
  get<T>(`${BASE_URL}/auth/sso/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

// Loose on purpose: the pages branch on `action` and read whichever fields it implies.
type SsoResponse = any;

export interface TotpEnrollment {
  secret: string;
  qr_code: string;
  recovery_codes: string[];
  detail?: string;
}

interface MfaParams {
  organization_id: string | null;
  member_id: string | null;
  intermediate_session_token: string | null;
}

// Reuses the same /auth/sso/* endpoints coverflow_fe's login already calls —
// there is no separate internal-only backend surface. Coverflow employees are
// gated on the server side (services/user_service.validate_admin_user +
// is_internal_email), not by a different auth flow here.
const ssoApi = {
  availableMethods: (email: string) => post<SsoResponse>("available-methods", { email }),
  stytchCallback: (token: string, tokenType: string) =>
    post<SsoResponse>("stytch-callback", { token, token_type: tokenType }),
  discoveryExchange: (intermediateToken: string, organizationId: string) =>
    post<SsoResponse>("discovery-exchange", {
      intermediate_token: intermediateToken,
      organization_id: organizationId,
    }),
  mfaEnroll: (params: MfaParams) => post<TotpEnrollment>("mfa/totp/enroll", params),
  mfaVerify: (params: MfaParams & { code: string; email?: string }) =>
    post<SsoResponse>("mfa/totp/verify", params),
};

export default ssoApi;
